module.exports = __webpack_public_path__ + "static/media/location.aedf0eb0.png";